import { createFileRoute } from "@tanstack/react-router";
import { CopilotAuthProvider } from "src/components/CopilotAuthProvider";
import { CopilotLayout } from "src/components/CopilotLayout";

function CopilotRoute() {
    return (
        <CopilotAuthProvider authMode="popup">
            <CopilotLayout />
        </CopilotAuthProvider>
    );
}

export const Route = createFileRoute("/copilot")({
    component: CopilotRoute,
});
